export default "/images/double-quotes.png?f46616eac5a8e2c9d91b7e4cd96eb2cd";